{
  "title": "Marketplace connections",
  "subtitle": "Connect your marketplace seller accounts so orders, stock, and returns can sync automatically.",
  "error": "Failed to load marketplace connections",
  "retry": "Retry",
  "mp_shopee": "Shopee",
  "mp_tiktok": "TikTok",
  "mp_lazada": "Lazada",
  "status_active": "Connected",
  "status_not_connected": "Not connected",
  "status_expired": "Expired",
  "status_revoked": "Revoked",
  "status_expiring_soon": "Expiring soon",
  "lbl_shop": "Shop: {{name}}",
  "lbl_shop_id": "Shop ID: {{id}}",
  "lbl_shop_code": "Shop code: {{code}}",
  "lbl_connected_at": "Connected {{date}}",
  "warn_refresh_expiring": "Refresh token expires {{date}} — reconnect before it expires",
  "warn_attention": "Needs attention: {{detail}}",
  "sync_paused": "Order sync paused",
  "reason_revoked": "{{marketplace}} rejected our credentials on {{date}}. This usually means the seller's password was changed. Reconnect to resume syncing.",
  "reason_expired": "This connection aged out on {{date}}. Reconnect to resume syncing.",
  "lbl_last_error": "Details: {{detail}}",
  "btn_connect": "Connect",
  "btn_reconnect": "Reconnect",
  "toast_connect_failed": "Failed to start the connection — please try again",
  "toast_oauth_success": "Marketplace connected successfully",
  "toast_oauth_error": "Failed to connect the marketplace",
  "status_disconnected": "Disconnected",
  "btn_disconnect": "Disconnect",
  "lbl_disconnected_at": "Disconnected {{date}}",
  "toast_disconnect_success": "Shop disconnected",
  "toast_disconnect_failed": "Failed to disconnect — please try again",
  "disconnect": {
    "title": "Disconnect {{shop}}?",
    "warning": "After disconnecting, Atlas will stop fetching new orders from {{shop}}. Orders placed on {{marketplace}} after this point will NOT reach the warehouse. Open orders already in Atlas continue as normal.",
    "counts": "{{openOrders}} open orders and {{activePromotions}} active promotions belong to this shop. They are kept exactly as they are.",
    "confirm": "Disconnect",
    "cancel": "Keep connected"
  },
  "connect": {
    "replace_title": "Replace the active shop on {{marketplace}}?",
    "replace": "{{current}} is currently active on {{marketplace}}. Connecting a new shop will disconnect it. Its orders and promotions are kept.",
    "confirm": "Continue",
    "cancel": "Cancel"
  },
  "listings": {
    "line": "{{mapped}} mapped · {{unmapped}} unmapped · {{duplicate}} duplicate",
    "refreshed": "refreshed {{rel}}",
    "never": "never refreshed",
    "view": "View",
    "refresh": "Refresh now",
    "multi_wh": "{{n}} warehouses — stock push held",
    "title": "Listings — {{mkp}}",
    "toast_refresh_success": "Refreshed: {{mapped}} mapped, {{unmapped}} unmapped, {{duplicate}} duplicate",
    "error": "Failed to load listing summary: {{detail}}",
    "summary_line": "{{mapped}} mapped",
    "col": {
      "seller_sku": "seller_sku",
      "status": "Status",
      "problem": "Problem"
    },
    "problem": {
      "unmapped": "Fix seller_sku in Seller Center, then Refresh",
      "duplicate": "Create the SKU in Atlas, then Refresh"
    },
    "ids_tooltip": "Product {{productId}} / Variant {{variantId}}",
    "status": {
      "mapped": "Mapped",
      "unmapped": "Unmapped",
      "duplicate": "Duplicate"
    }
  },
  "btn_switch": "Switch shop",
  "lbl_shop_unnamed": "Unnamed shop",
  "lbl_previous_one": "{{count}} previous connection",
  "lbl_previous_other": "{{count}} previous connections",
  "col": {
    "marketplace": "Marketplace",
    "shop": "Shop",
    "status": "Status",
    "listings": "Listings",
    "refreshed": "Last refresh",
    "actions": "Actions"
  }
}
